import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import api from '../services/api';
import { BannerCarouselSlim } from '../components/BannerCarousel';

export default function VeiculoDetalhe() {
  const { id } = useParams();
  const nav    = useNavigate();
  const [veiculo, setVeiculo] = useState(null);
  const [foto, setFoto]       = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/veiculos/${id}`)
      .then(({ data }) => setVeiculo(data))
      .catch(() => nav('/veiculos'))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return <><Navbar /><p className="carregando">Carregando...</p></>;
  if (!veiculo) return null;

  const fotos = veiculo.fotos || [];
  const fmtPreco = v => v ? `R$ ${Number(v).toLocaleString('pt-BR')}` : 'A consultar';
  const msgWA = encodeURIComponent(`Olá, vi seu veículo ${veiculo.marca} ${veiculo.modelo} ${veiculo.ano} anunciado na plataforma Web Heritage e tenho interesse em saber mais informações.`);
  const linkWA = `https://wa.me/55${veiculo.whatsapp_vendedor?.replace(/\D/g,'')}?text=${msgWA}`;

  const specs = [
    ['Marca',         veiculo.marca],
    ['Modelo',        veiculo.modelo],
    ['Versão',        veiculo.versao],
    ['Ano',           veiculo.ano],
    ['Quilometragem', veiculo.quilometragem ? `${Number(veiculo.quilometragem).toLocaleString('pt-BR')} km` : null],
    ['Câmbio',        veiculo.cambio],
    ['Combustível',   veiculo.combustivel],
    ['Cor',           veiculo.cor],
    ['Motor',         veiculo.motor],
    ['Cidade/UF',     veiculo.cidade && veiculo.estado ? `${veiculo.cidade} / ${veiculo.estado}` : null],
  ].filter(([,v]) => v);

  const flags = [
    ['original',              'Original'],
    ['placa_preta',           'Placa preta'],
    ['restaurado',            'Restaurado'],
    ['pecas_originais',       'Peças originais'],
    ['historico_manutencao',  'Histórico de manutenção'],
    ['documentacao_em_dia',   'Documentação em dia'],
    ['quitado',               'Quitado'],
    ['aceita_negociacao',     'Aceita negociação'],
    ['aceita_troca',          'Aceita troca'],
  ];

  return (
    <>
      <Navbar />

      <div style={{ background: 'var(--cream)', minHeight: 'calc(100vh - 112px)', padding: '40px 0 72px' }}>
        <div className="container">
          <button onClick={() => nav('/veiculos')} style={{ background:'none', border:'none', cursor:'pointer', color:'var(--rust)', fontSize:13, fontWeight:900, letterSpacing:.5, marginBottom:28, display:'flex', alignItems:'center', gap:6 }}>
            &larr; Voltar ao catálogo
          </button>

          <div className="veiculo-detalhe-grid">

            {/* Coluna esquerda */}
            <div>
              {/* Galeria */}
              <div style={{ borderRadius:'var(--r-md)', overflow:'hidden', height:420, background:'#f0e8d8', display:'flex', alignItems:'center', justifyContent:'center', marginBottom:10 }}>
                {fotos[foto]?.url
                  ? <img src={fotos[foto].url} alt={`${veiculo.marca} ${veiculo.modelo}`} style={{ width:'100%', height:'100%', objectFit:'cover' }} />
                  : <span style={{ fontSize:80, opacity:.25 }}>&#128663;</span>}
              </div>
              {fotos.length > 1 && (
                <div style={{ display:'flex', gap:8, overflowX:'auto', paddingBottom:4 }}>
                  {fotos.map((f, i) => (
                    <div key={f.id} onClick={() => setFoto(i)} style={{ width:80, height:58, flexShrink:0, borderRadius:'var(--r-sm)', overflow:'hidden', cursor:'pointer', border:`2px solid ${i===foto?'var(--rust)':'transparent'}`, transition:'.15s' }}>
                      <img src={f.url} alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }} />
                    </div>
                  ))}
                </div>
              )}

              {/* Info principal */}
              <div style={{ marginTop:32 }}>
                <div style={{ display:'flex', gap:8, marginBottom:12 }}>
                  <span className={`badge badge-${veiculo.status}`}>{veiculo.status?.replace('_',' ')}</span>
                  {!!veiculo.destaque && <span className="badge badge-premium">Destaque</span>}
                </div>
                <h1 style={{ fontFamily:"'Playfair Display',serif", fontSize:34, fontWeight:600, marginBottom:6 }}>
                  {veiculo.marca} {veiculo.modelo} {veiculo.versao && `— ${veiculo.versao}`}
                </h1>
                <div style={{ fontSize:30, fontWeight:900, color:'var(--rust)', marginBottom:20 }}>{fmtPreco(veiculo.preco)}</div>

                {/* Badges especiais */}
                <div style={{ display:'flex', gap:8, flexWrap:'wrap', marginBottom:28 }}>
                  {!!veiculo.original    && <span style={{ fontSize:10, background:'rgba(30,125,71,.12)', color:'#1e7d47', padding:'5px 12px', borderRadius:'var(--r-sm)', fontWeight:900, letterSpacing:.5, textTransform:'uppercase' }}>Original</span>}
                  {!!veiculo.placa_preta && <span style={{ fontSize:10, background:'var(--ink)', color:'var(--gold)', padding:'5px 12px', borderRadius:'var(--r-sm)', fontWeight:900, letterSpacing:.5, textTransform:'uppercase' }}>Placa preta</span>}
                  {!!veiculo.restaurado  && <span style={{ fontSize:10, background:'rgba(37,99,235,.1)', color:'#2563eb', padding:'5px 12px', borderRadius:'var(--r-sm)', fontWeight:900, letterSpacing:.5, textTransform:'uppercase' }}>Restaurado</span>}
                </div>

                {/* Especificações */}
                <h2 style={{ fontFamily:"'Playfair Display',serif", fontSize:20, marginBottom:14 }}>Especificações</h2>
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', background:'#fff', border:'1px solid var(--border)', borderRadius:'var(--r-md)', overflow:'hidden', marginBottom:28 }}>
                  {specs.map(([k,v], i) => (
                    <div key={k} style={{ padding:'12px 18px', borderBottom:'1px solid var(--border)', borderRight: i%2===0 ? '1px solid var(--border)' : 'none', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                      <span style={{ fontSize:11, color:'var(--ink-muted)', letterSpacing:.5, textTransform:'uppercase' }}>{k}</span>
                      <span style={{ fontSize:13, fontWeight:700 }}>{v}</span>
                    </div>
                  ))}
                </div>

                {/* Detalhes do clássico */}
                <h2 style={{ fontFamily:"'Playfair Display',serif", fontSize:20, marginBottom:14 }}>Detalhes do clássico</h2>
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10, marginBottom:28 }}>
                  {flags.map(([field, label]) => (
                    <div key={field} style={{ display:'flex', alignItems:'center', gap:8, fontSize:13 }}>
                      <span style={{ color: veiculo[field] ? '#1e7d47' : '#ccc', fontWeight:900, fontSize:15 }}>{veiculo[field] ? '✓' : '✗'}</span>
                      <span style={{ color: veiculo[field] ? 'var(--ink)' : 'var(--ink-muted)' }}>{label}</span>
                    </div>
                  ))}
                </div>

                {/* Descrição */}
                {veiculo.descricao && (
                  <div style={{ marginBottom:24 }}>
                    <h2 style={{ fontFamily:"'Playfair Display',serif", fontSize:20, marginBottom:12 }}>Descrição</h2>
                    <p style={{ fontSize:14, lineHeight:1.75, color:'var(--ink-mid)', background:'#fff', padding:20, borderRadius:'var(--r-md)', border:'1px solid var(--border)' }}>{veiculo.descricao}</p>
                  </div>
                )}

                {/* Aviso legal */}
                <div className="aviso-responsabilidade">
                  <strong style={{ fontSize:10, letterSpacing:1.2, textTransform:'uppercase', color:'var(--rust)', display:'block', marginBottom:6 }}>Atenção &mdash; Responsabilidade da plataforma</strong>
                  A Web Heritage atua apenas como plataforma de divulgação de anúncios. As informações deste veículo foram fornecidas pelo anunciante. A negociação, pagamento, documentação, vistoria, transferência, estado de conservação e garantia do veículo são de responsabilidade exclusiva do comprador e do vendedor. Recomendamos que o comprador realize todas as verificações necessárias antes de concluir qualquer negociação.
                </div>
              </div>
            </div>

            {/* Coluna direita - contato */}
            <div>
              <div className="card" style={{ padding:28, position:'sticky', top:132 }}>
                <div style={{ fontSize:10, letterSpacing:2, textTransform:'uppercase', color:'var(--rust)', fontWeight:900, marginBottom:14 }}>Contato do anunciante</div>
                <div style={{ fontFamily:"'Playfair Display',serif", fontSize:22, fontWeight:600, marginBottom:4 }}>{veiculo.nome_vendedor || 'Anunciante'}</div>
                {veiculo.cidade_vendedor && (
                  <p style={{ fontSize:13, color:'var(--ink-muted)', marginBottom:20 }}>&#128205; {veiculo.cidade_vendedor}{veiculo.estado_vendedor && ` / ${veiculo.estado_vendedor}`}</p>
                )}

                <div style={{ background:'var(--cream-dark)', borderRadius:'var(--r-sm)', padding:16, marginBottom:20, fontSize:13, color:'var(--ink-muted)', lineHeight:1.6 }}>
                  O contato é direto entre você e o anunciante. A Heritage não participa da negociação.
                </div>

                <a href={linkWA} target="_blank" rel="noopener noreferrer" className="btn btn-primary" style={{ display:'flex', width:'100%', marginBottom:12, minHeight:48, fontSize:12 }}>
                  &#128172; Contatar pelo WhatsApp
                </a>
                {veiculo.email_vendedor && (
                  <a href={`mailto:${veiculo.email_vendedor}`} className="btn btn-outline" style={{ display:'flex', width:'100%', minHeight:44, fontSize:12 }}>
                    &#9993; Enviar e-mail
                  </a>
                )}

                <div style={{ borderTop:'1px solid var(--border)', marginTop:22, paddingTop:18 }}>
                  <p style={{ fontSize:11, color:'var(--ink-muted)', lineHeight:1.65 }}>
                    <strong style={{ display:'block', marginBottom:4, color:'var(--ink)' }}>Antes de negociar:</strong>
                    Verifique a documentação, o histórico, eventuais débitos e restrições. Faça uma vistoria presencial antes de fechar negócio.
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <section aria-label="Produtos e serviços Heritage">
        <BannerCarouselSlim />
      </section>
    </>
  );
}
